import React, { useContext, useEffect, useState } from 'react';
import PostAuthor from '../components/PostAuthor';
import { Link, useParams } from 'react-router-dom';
import Loader from '../components/Loader';
import DeletePost from './DeletePost';
import { DiscussionEmbed } from 'disqus-react';
import { UserContext } from '../context/userContext';
import axios from 'axios';

function PostDetail() {
  const { currentUser } = useContext(UserContext);
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const getPost = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/posts/${id}`);
        setPost(response.data);
      } catch (err) {
        setError(err.response?.data?.message || err.message);
      }
      setIsLoading(false);
    };
    getPost();
  }, [id]);

  if (isLoading) return <Loader />;
  if (error) return <p className="error">{error}</p>;

  // Replace with your actual Disqus shortname (from Disqus dashboard)
  const disqusShortname = "radblok";  

  const disqusConfig = {
    url: `https://radblok-dz7cdgzl9-radlees-projects.vercel.app/posts/${id}`,
    identifier: id,
    title: post ? post.title : '',
  };

  return (
    <section className="post-detail">
      {post && (
        <div className="container post-detail__container">
          <div className="post-detail__header">
            <PostAuthor authorID={post.author} createdAt={post.createdAt} />
            {currentUser?.id === post?.author && (
              <div className="post-detail__buttons">
                <Link to={`/posts/${post?._id}/edit`} className="btn sm primary">
                  Edit
                </Link>
                <DeletePost postId={id} />
              </div>
            )}
          </div>
          <h1>{post.title}</h1>
          <div className="post-detail__thumbnail">
            <img src={post.thumbnail} alt="Thumbnail" />
          </div>
          <div dangerouslySetInnerHTML={{ __html: post.content }} />
        </div>
      )}
      <br />
      <div className="disqus">
        <DiscussionEmbed shortname={disqusShortname} config={disqusConfig} />
      </div>
    </section>
  );
}

export default PostDetail;
